<app-preloader></app-preloader>
<router-outlet></router-outlet>
<app-footer *ngIf="!(location == '/error' || location == '/coming-soon' || location == '/live-tracker')"></app-footer>